export enum LearnerSearchMixpanelEvents {
  LEARNER_ADVANCED_SEARCH_SELECTS_TYPE_FILTER = 'learner_advanced_search_selects_type_filter',
  LEARNER_ADVANCED_SEARCH_SELECTS_TAG = 'learner_advanced_search_selects_tag',
  LEARNER_ADVANCED_SEARCH_SELECTS_SKILL = 'learner_advanced_search_selects_skill',
  LEARNER_ADVANCED_SEARCH_SELECTS_UPDATED_FILTER_VALUE = 'learner_advanced_search_selects_updated_filter_value',
  LEARNER_ADVANCED_SEARCH_SELECTS_UPDATED_BY_FILTER_VALUE = 'learner_advanced_search_selects_updated_by_filter_value',
  LEARNER_ADVANCED_SEARCH_CHANGES_SORT = 'learner_advanced_search_changes_sort',
  LEARNER_ADVANCED_SEARCH_USES_QUICK_LINK = 'learner_advanced_search_uses_quick_link',
  LEARNER_ADVANCED_SEARCH_CLICKS_RESULT = 'learner_advanced_search_clicks_result',
  LEARNER_ADVANCED_SEARCH_LOAD_MORE = 'learner_advanced_search_load_more',
  LEARNER_ADVANCED_SEARCH_GUIDE_SHOW_MORE = 'learner_advanced_search_guide_show_more',
}
